import { render, staticRenderFns } from "./ScheduleMessageView.vue?vue&type=template&id=61985798&scoped=true&"
import script from "./ScheduleMessageView.vue?vue&type=script&lang=js&"
export * from "./ScheduleMessageView.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleMessageView.vue?vue&type=style&index=0&id=61985798&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61985798",
  null
  
)

export default component.exports